<template>
  <v-row>
    <v-col align="left" class="text-h5 text-md-right text-sm-center black--text font-weight-bold" col="2" sm="12" xs="12" md="6">
      {{ label.toUpperCase() }}:
    </v-col>
    <v-col class="text-h5 text-lg-left text-md-left text-sm-center  text-xs-center black--text py-sm-2 py-xs-2" col="2" sm="12" xs="12" md="6">
      {{ value.toUpperCase() }}
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "LabelValueComponent",
  props: {
    label: String,
    value: String
  }
}
</script>